import Box from "@mui/joy/Box"
import CircularProgress from "@mui/joy/CircularProgress"
import Typography from "@mui/joy/Typography"
import { useTranslation } from "react-i18next"
import type { NavigationModalControlProps } from "@levana/ui/NavigationModalDialog"

import FaucetForm from "@perps/faucet/FaucetForm"
import type { ContextStoreProp } from "@future/context/store"

import { useController } from "./controller"

export interface HeaderFaucetValidateProps
  extends ContextStoreProp<"standard">,
    NavigationModalControlProps {
  onSubmit: () => void
  onFailure: () => void
}

const HeaderFaucetValidate = (props: HeaderFaucetValidateProps) => {
  const controller = useController(props)
  const { t } = useTranslation("faucet")

  return (
    <>
      <Typography level="body-md" sx={{ textAlign: "center", mb: 4 }}>
        {t("modal.validate.description")}
      </Typography>

      {controller.isLoading ? (
        <Box sx={{ lineHeight: 0, textAlign: "center" }}>
          <CircularProgress />
        </Box>
      ) : (
        <FaucetForm
          submitFromCaptcha
          onSubmit={controller.handleSubmit}
          onSuccess={controller.handleSuccess}
          onFailure={controller.handleFailure}
          getCw20s={controller.getCw20s}
          contextStore={props.contextStore}
        />
      )}
    </>
  )
}

export default HeaderFaucetValidate
